import Modal from '@/components/Modal/Modal';
import useModalState from '@/hooks/pure/useModalState';
import useFeedbackSourceStore from '@/stores/Feedback/FeedbackSourceStore';
import useLocaleStore from '@/stores/LocaleStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { SOURCE_TYPE } from '@/types/feedbackConst';

import { ProviderContainer } from '../../components/ProviderContainer';
import type { IntegrationItemProps } from '../../types';
import type { GooglePlayStoreInfo } from '../types';
import GooglePlayStoreConnectModal from './GooglePlayStoreConnectModal';
import { useGooglePlayStore } from './useGooglePlayStore';

export const GooglePlayStoreItem = (props: IntegrationItemProps) => {
  const { isConnector } = props;
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const fetchFeedbackSources = useFeedbackSourceStore(
    (state) => state.fetchFeedbackSources,
  );
  const regionMap = useLocaleStore((state) => state.regionMap);

  const { googlePlayStoreInfo, disconnectGooglePlayStoreMutation, refetch } =
    useGooglePlayStore(!isConnector);

  const connectModalState = useModalState();

  const handleConnectComplete = async () => {
    if (!currWorkspace) return;
    await connectModalState.close();
    await fetchFeedbackSources(currWorkspace.alias);
    await refetch();
  };

  const handleDisconnect = (info: GooglePlayStoreInfo) => {
    disconnectGooglePlayStoreMutation({ app_id: info.alias });
  };

  return (
    <>
      <ProviderContainer
        multiInfoEnabled={true}
        connected={!!googlePlayStoreInfo && googlePlayStoreInfo.length > 0}
        source={SOURCE_TYPE.GOOGLE_PLAY}
        description="Import reviews as feedbacks into Syncly."
        onAddInfoClick={() => connectModalState.open()}
        connectedDisplay={(info) => {
          const country =
            regionMap[info.app_info.country.toUpperCase()]?.country;
          const name = info.app_info.title;
          return `${name} | ${country}`;
        }}
        infos={googlePlayStoreInfo || []}
        onDisconnect={handleDisconnect}
        onConnectClick={() => connectModalState.open()}
      />
      <Modal
        status={connectModalState.status}
        closeModal={connectModalState.close}
      >
        <GooglePlayStoreConnectModal
          onConnectComplete={handleConnectComplete}
        />
      </Modal>
    </>
  );
};
